import { createSlice } from "@reduxjs/toolkit";
const initialCandidateState = {
  actionLoading: false,
  listLoading: false,
  selectedCandidate: null,
  candidates: [],
  limit: null,
  filtersForNextPreCandidate: null,
  totalPages: null,
  totalResults: null,
  page: null,
  meetingMembers: [],
  workFlow: null,
  selectedFeedbackDetails: null,
};

export const candidateManagementSlice = createSlice({
  name: "candidateManagementSlice",
  initialState: initialCandidateState,
  reducers: {
    startCall: (state, action) => {
      if (action.payload === "action") {
        state.actionLoading = true;
      } else {
        state.listLoading = true;
      }
    },

    stopCall: (state, action) => {
      if (action.payload === "action") {
        state.actionLoading = false;
      } else {
        state.listLoading = false;
      }
    },
    getAllCandidates: (state, action) => {
      const { page, limit, totalPages, totalResults, candidates } = action?.payload?.data?.data;
      state.candidates = candidates;
      state.limit = limit;
      state.totalPages = totalPages;
      state.totalResults = totalResults;
      state.page = page;
      state.listLoading = false;
    },
    setSelectedCandidate: (state, action) => {
      let meetingMembers = null;
      const candidate = action?.payload?.candidate;
      if (candidate !== null) {
        state.meetingMembers = action?.payload?.candidate?.meetingMembers;
      }

      if (candidate?.candidate) {
        state.selectedCandidate = candidate?.candidate;
      } else {
        state.selectedCandidate = candidate;
      }

      state.actionLoading = false;
    },
    cleanUpSelectedCandidate: (state, action) => {
      state.selectedCandidate = null;
    },
    setCandidateID: (state, action) => {
      state.jobId = action?.payload;
      state.actionLoading = false;
    },
    setFiltersForNextPreCandidate: (state, action) => {
      state.filtersForNextPreCandidate = action.payload;
    },
    setWorkFlow: (state, action) => {
      state.workFlow = action?.payload;
    },
    setSelectedFeedbackDetails: (state, action) => {
      state.selectedFeedbackDetails = action?.payload;
    },
  },
});
